import { Navigate, useLocation } from 'react-router-dom';

type Props = {
  to: string;
  params?: Record<string, string>;
};

export const RedirectWithSearchParams = ({ to, params }: Props) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  Object.entries(params ?? {}).forEach(([key, value]) => {
    searchParams.set(key, value);
  });

  const queryString = searchParams.toString();

  return <Navigate to={queryString ? `${to}?${queryString}` : to} replace />;
};
